import React from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { TIER_GRADIENTS } from '../../utils/tier';

const TIER_THEMES = {
  Basic: {
    gradient: TIER_GRADIENTS.Basic,
    fg: '#FFFFFF',
    accent: '#F2D5C2',
    shadow: 'rgba(136, 94, 75, 0.4)',
  },
  Standard: {
    gradient: TIER_GRADIENTS.Standard,
    fg: '#FFFFFF',
    accent: '#E5E5E5',
    shadow: 'rgba(110, 110, 110, 0.3)',
  },
  Advanced: {
    gradient: TIER_GRADIENTS.Advanced,
    fg: '#FFFFFF',
    accent: '#E6C872',
    shadow: 'rgba(67, 51, 24, 0.38)',
  },
  Elite: {
    gradient: TIER_GRADIENTS.Elite,
    fg: '#FFFFFF',
    accent: '#66C6F0',
    shadow: 'rgba(4, 20, 157, 0.45)',
  },
};

export default function CustomerCategoryCard({ tier = 'Basic', compact = false, mobileShort = true }) {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('sm'));

  const key = TIER_THEMES[tier] ? tier : 'Basic';
  const style = TIER_THEMES[key];

  return (
    <Box
      sx={{
        display: 'inline-flex',
        width: 'fit-content',
        alignItems: 'center',
        gap: 1,
        px: compact ? 1 : isXs ? 1 : 1.5,
        py: compact ? 0.25 : isXs ? 0.5 : 0.75,
        borderRadius: 999,
        position: 'relative',
        color: style.fg,
        backgroundImage: style.gradient,
        border: '1px solid rgba(255,255,255,0.24)',
        boxShadow: `0 6px 16px ${style.shadow}`,
        fontFamily: 'Poppins, sans-serif',
        maxWidth: '100%',
        overflow: 'hidden',
        '&::after': {
          content: '""',
          position: 'absolute',
          inset: 0,
          background: 'rgba(255,255,255,0.08)',
          mixBlendMode: 'soft-light',
        },
      }}
    >
      <Box
        sx={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          bgcolor: style.accent,
          flex: '0 0 auto',
          boxShadow: `0 0 8px ${style.accent}`,
          position: 'relative',
          zIndex: 1,
        }}
      />
      <Typography
        noWrap
        variant={compact || isXs ? 'caption' : 'body2'}
        sx={{ fontWeight: 600, color: style.fg, position: 'relative', zIndex: 1 }}
        title={mobileShort && isXs ? tier : `${tier}`}
      >
        {mobileShort && isXs ? `${tier}` : `${tier}`}
      </Typography>
    </Box>
  );
}
